export default {
  strict: true,
  namespaced: true,
  state: {
    ongoing: false,
    phone: '',
    name: '',
    isMute: false
  },
  mutations: {
    startCall (state, user) {
      state.ongoing = true
      state.phone = user.phone
      state.name = user.name
      state.isMute = false
    },
    endCall (state) {
      state.ongoing = false
      state.phone = ''
      state.name = ''
      state.isMute = false
    },
    setMute (state, value) {
      state.isMute = value
    }
  },
  sharedMutations: [
    'phone/startCall',
    'phone/endCall',
    'phone/setReady'
  ]
}



// WEBPACK FOOTER //
// ./src/store/phone-app.js